import { ENRICHMENT_ANSWER_TYPE_RATING } from "../enrichmentAnswerTypes";

export function isEnrichmentAnswerTypeRating(enrichment) {
    return enrichment.answer_type == ENRICHMENT_ANSWER_TYPE_RATING;
}
